import React from "react";
import { EstadoContenido } from "../../../../utils/constants";
import { ConfiguracionLogosPage } from "..";

const LogosPublicadoPage = () => (
  <ConfiguracionLogosPage estado={EstadoContenido.Publicado} />
);

export default LogosPublicadoPage;
